import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { flatten as _flatten } from 'lodash';
import { CompositeLayer } from '@deck.gl/core';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { mapConstants } from '@gisatcz/ptr-core';

var TiledLayer = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(TiledLayer, _CompositeLayer);

  var _super = _createSuper(TiledLayer);

  function TiledLayer() {
    _classCallCheck(this, TiledLayer);

    return _super.apply(this, arguments);
  }

  _createClass(TiledLayer, [{
    key: "renderLayers",
    value: function renderLayers() {
      return [this.renderTiledLayer()];
    }
  }, {
    key: "getValidUrlTemplates",
    value: function getValidUrlTemplates(url) {
      var invalidTemplateSegment = '{s}';

      if (url.includes(invalidTemplateSegment)) {
        var subDomainNames = ['a', 'b', 'c'];
        var urls = [];
        subDomainNames.forEach(function (subDomainName) {
          var validUrl = url.replace(invalidTemplateSegment, subDomainName);
          urls.push(validUrl);
        });
        return urls;
      } else {
        return url;
      }
    }
  }, {
    key: "renderTiledLayer",
    value: function renderTiledLayer() {
      var _this = this;

      var _this$props = this.props,
          options = _this$props.options,
          key = _this$props.key;
      var url = options.url,
          urls = options.urls,
          minNativeZoom = options.minNativeZoom,
          maxNativeZoom = options.maxNativeZoom,
          tileSize = options.tileSize;
      var finalUrls = urls ? _flatten(urls.map(function (url) {
        return _this.getValidUrlTemplates(url);
      })) : this.getValidUrlTemplates(url);
      return new TileLayer({
        id: "".concat(key, "-tileLayer"),
        data: finalUrls,
        minZoom: minNativeZoom || mapConstants.defaultLevelsRange[0],
        maxZoom: maxNativeZoom || mapConstants.defaultLevelsRange[1],
        tileSize: tileSize || 256,
        renderSubLayers: function renderSubLayers(props) {
          var _props$tile$bbox = props.tile.bbox,
              west = _props$tile$bbox.west,
              south = _props$tile$bbox.south,
              east = _props$tile$bbox.east,
              north = _props$tile$bbox.north;
          return new BitmapLayer(props, {
            data: null,
            image: props.data,
            bounds: [west, south, east, north]
          });
        }
      });
    }
  }]);

  return TiledLayer;
}(CompositeLayer);

export default TiledLayer;